module.exports = {
	"description": "metals",
	"metals": [
		"actinium",
		"aluminium",
		"americium",
		"barium",
		"berkelium",
		"beryllium",
		"bismuth",
		"bohrium",
		"cadmium",
		"calcium",
		"californium",
		"cerium",
		"cesium",
		"chromium",
		"cobalt",
		"copper",
		"curium",
		"darmstadtium",
		"dubnium",
		"dysprosium",
		"einsteinium",
		"erbium",
		"europium",
		"fermium",
		"francium",
		"gadolinium",
		"gallium",
		"gold",
		"hafnium",
		"hassium",
		"holmium",
		"indium",
		"iridium",
		"iron",
		"lanthanum",
		"lawrencium",
		"lead",
		"lithium",
		"lutetium",
		"magnesium",
		"manganese",
		"meitnerium",
		"mendelevium",
		"mercury",
		"molybdenum",
		"neodymium",
		"neptunium",
		"nickel",
		"niobium",
		"nobelium",
		"osmium",
		"palladium",
		"platinum",
		"plutonium",
		"polonium",
		"potassium",
		"praseodymium",
		"promethium",
		"protactinium",
		"radium",
		"rhenium",
		"rhodium",
		"roentgenium",
		"rubidium",
		"ruthenium",
		"rutherfordium",
		"samarium",
		"scandium",
		"seaborgium",
		"silver",
		"sodium",
		"strontium",
		"tantalum",
		"technetium",
		"terbium",
		"thallium",
		"thorium",
		"thulium",
		"tin",
		"titanium",
		"tungsten",
		"ununbium",
		"ununhexium",
		"ununpentium",
		"ununquadium",
		"ununtrium",
		"uranium",
		"vanadium",
		"ytterbium",
		"yttrium",
		"zinc",
		"zirconium"
	]
};


/** WEBPACK FOOTER **
 ** ./corpora/data/materials/metals.json
 **/